import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.pricingProcedures.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.pricingProcedures.actionsLoading;
export const getItems = (state:RootState) => state.pricingProcedures.items;
export const getItemsSelect = (state:RootState) => state.pricingProcedures.dropDownItems;
export const getItemsCount = (state:RootState) => state.pricingProcedures.itemsCount;
export const getItemForEdit = (state:RootState) => state.pricingProcedures.itemForEdit;
export const getError = (state:RootState) => state.pricingProcedures.error;
export const getErrorAction = (state:RootState) => state.pricingProcedures.errorAction;
export const validationErrors = (state: RootState) => state.pricingProcedures.validationErrors;
export const getFilters = (state: RootState) => state.pricingProcedures.filters;
